import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Field } from 'redux-form';
import {
  Table,
  TableContainer,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Tooltip
} from '@material-ui/core';
import CustomInput from '../../../../../utils/redux-forms-custom-fields/CustomInput';
import CustomInputCheckbox from '../../../../../utils/redux-forms-custom-fields/CustomInputCheckbox';
const ViewerTiers = ({
  fields, 
  meta: { error },
  questForm,
  parametersSubTab,
  streamingQuest
}) => {
  const questStarted = React.useMemo(() => {
    if (!questForm?.values?.startDateTime) return false;
    return moment(questForm.values.startDateTime).diff(moment(Date.now())) < 0;
  }, [questForm?.values?.startDateTime]);
  
  const isYoutubeVideoQuest = questForm?.values?.type === 'youtube-video';
  const showMetricField = streamingQuest || isYoutubeVideoQuest;
  const metricFieldName = isYoutubeVideoQuest ? 'minimumAveragePlayCount' : 'minimumAverageViewers';
  const metricLabel = isYoutubeVideoQuest ? 'Min. Avg. Play Count' : 'Min. Avg. Viewers';
  const metricPlaceholder = isYoutubeVideoQuest ? 'Minimum Average Play Count' : 'Minimum Average Viewers';

  return (
    <section className="WhiteListWrapper">
      <TableContainer>
        <Table>
          {questForm?.values?.viewerTiers?.length > 0 && (
            <TableHead>
              <TableRow>
                <TableCell align="center">Spots Available</TableCell>
                {showMetricField && <TableCell align="center">{metricLabel}</TableCell>}
                <TableCell align="center">
                  $ Amount &nbsp;
                  <Tooltip title='Put "0" for no message. Put "-1" for free key. Put "-2" for points.' placement="top">
                    <i className="fa fa-info-circle" />
                  </Tooltip>
                </TableCell>
                <TableCell align="center">Noiz Points</TableCell>
                <TableCell align="center">Tier Goal</TableCell>
                <TableCell align="center">Enable Goal</TableCell>
                <TableCell />
              </TableRow>
            </TableHead>
          )}
          <TableBody>
            {fields.map((item, index) => (
              <TableRow key={index}>
                <TableCell>
                  <Field
                    name={`${item}.spotsAvailable`}
                    id={`${item}.spotsAvailable`}
                    type="text"
                    component={CustomInput}
                    placeholder="Spots Available"
                    onlyNumbers="true"
                  />
                </TableCell>
                {showMetricField && (
                  <TableCell>
                    <Field
                      name={`${item}.${metricFieldName}`}
                      id={`${item}.${metricFieldName}`}
                      type="text"
                      component={CustomInput}
                      placeholder={metricPlaceholder}
                      onlyNumbers="true"
                    />
                  </TableCell>
                )}
                <TableCell>
                  <Field
                    name={`${item}.paymentAmount`} 
                    id={`${item}.paymentAmount`}
                    type="text"
                    component={CustomInput}
                    placeholder="Payment Amount"
                  />
                </TableCell>
                <TableCell>
                  <Field
                    name={`${item}.noizPoints`}
                    id={`${item}.noizPoints`}
                    type="text" 
                    component={CustomInput}
                    placeholder="ARKade Ticket"
                    onlyNumbers="true"
                  />
                </TableCell>
                <TableCell>
                  <Field
                    name={`${item}.goal`}
                    id={`${item}.goal`}
                    type="text"
                    component={CustomInput}
                    placeholder="Goal Description"
                  />
                </TableCell>
                <TableCell align="center">
                  <Field
                    name={`${item}.goalEnabled`}
                    id={`${item}.goalEnabled`}
                    type="checkbox"
                    component={CustomInputCheckbox}
                  />
                </TableCell>
                <TableCell align="center">
                  {!questStarted && (
                    <button
                      className="RepeaterWrapper__item-remove"
                      type="button"
                      onClick={() => {
                        if (window.confirm('Are you sure you want to remove this tier?')) {
                          fields.remove(index);
                        }
                      }}
                    >
                      <i className="fa fa-trash" />
                    </button>
                  )}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      {error && <span className="RepeaterWrapper__error">{error}</span>}
      
      {(showMetricField || (!showMetricField && !questForm?.values?.viewerTiers?.length)) && (
        <button 
          className="RepeaterWrapper__add-item" 
          type="button" 
          onClick={() => fields.push({ [metricFieldName]: 0 })}
        >
          Add {!showMetricField ? 'A Payment Amount' : 'Another Viewer Tier'} 
        </button>
      )}
    </section>
  );
};

ViewerTiers.propTypes = {
  fields: PropTypes.object.isRequired,
  meta: PropTypes.object.isRequired,
  questForm: PropTypes.object,
  parametersSubTab: PropTypes.number.isRequired,
  streamingQuest: PropTypes.bool
};

export default React.memo(ViewerTiers);